// @flow
import React, { useEffect, useState } from "react";
import { Row, Button } from "react-bootstrap";
import Dropzone from "react-dropzone";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import Spinner from "./Spinner";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DocumentLink from "./DocumentLink";
import HiddenValue from "./HiddenValue";
const CompactFileUploader = ({ accept, ...props }) => {
  const { t } = useTranslation(["components", "common"]);
  // FileUploader.defaultProps = {
  //   showPreview: true,
  // };
  const { user } = useSelector((state) => ({
    user: state.Auth.user,
  }));
  const [selectedFiles, setSelectedFiles] = useState(props.documents);
  const [loading, setLoading] = useState(false);
  /**
   * Handled the accepted files and shows the preview
   */

  useEffect(() => {
    if (props.documents) {
      setSelectedFiles(props.documents);
    }
  }, [props.documents]);

  const handleAcceptedFiles = (files) => {
    console.log("files", files);
    let allFiles = files;
    console.log("allFiles", allFiles);
    setLoading(true);
    let existing_documents = [];
    // if (props.showPreview) {
    files.map((file) => {
      Object.assign(file, {
        preview:
          file["type"].split("/")[0] === "image"
            ? URL.createObjectURL(file)
            : null,
        formattedSize: formatBytes(file.size),
      });

      return null; // map arrow function expects a return value. As the return value is not used, the return value is null.
    });

    if (props.documentTypes && props.documentTypes.length === 1) {
      files.map((file) => {
        Object.assign(file, {
          document_type: props.documentTypes[0],
        });
        return null;
      });
    }

    files.forEach((file) => {
      // check for existing documents
      console.log("files props.documents", props.documents);
      const document_exists =
        props.documents && props.documents.length > 0
          ? props.documents.items
            ? props.documents.items.find(
                (element) => element.name === file.name
              )
            : props.documents.find((element) => element.name === file.name)
          : null;
      console.log("files document_exists", document_exists);
      if (document_exists === "undefined" || document_exists == null) {
      } else {
        existing_documents.push(document_exists);
        files = files.filter((file) => file.name !== document_exists.name);
      }
    });
    if (existing_documents.length > 0) {
      props.showAlertModal(existing_documents);
      existing_documents = null;
    }

    allFiles = selectedFiles;
    allFiles.push(...files);
    setSelectedFiles(allFiles);
    setLoading(false);
    // }

    if (props.onFileUpload) {
      props.onFileUpload(allFiles);
    }
  };

  /**
   * Formats the size
   */
  const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };

  /*
   * Removes the selected file
   */
  const removeFile = (file) => {
    const newFiles = [...selectedFiles];
    if (!newFiles[file].id) {
      newFiles.splice(newFiles.indexOf(file), 1);
      props.updateFilesHandler(newFiles);
      console.log("newFiles", newFiles);
      setSelectedFiles(newFiles);
    } else {
      newFiles[file].delete = true;
      props.updateFilesHandler(newFiles);
      setSelectedFiles(newFiles);
    }
  };

  const reAddFile = (file) => {
    const newFiles = [...selectedFiles];
    newFiles[file].delete = false;
    props.updateFilesHandler(newFiles);
    setSelectedFiles(newFiles);
  };

  return (
    <>
      <Dropzone
        {...props}
        accept={accept}
        onDrop={(acceptedFiles) => handleAcceptedFiles(acceptedFiles)}
        onDropRejected={(fileRejections) => {
          fileRejections.forEach((file) => {
            toast.error(`wrong file format: ${file.file.name}`);
          });
        }}
      >
        {({ getRootProps, getInputProps }) => (
          <div className="dropzone" {...getRootProps()}>
            <div className="dz-message needsclick">
              <input {...getInputProps({ accept })} />
              {!loading && (
                <i className="h3 text-muted dripicons-cloud-upload"></i>
              )}
              {loading && <Spinner />}
              <h5>{t("Drop files here or click to upload.")}</h5>
            </div>
          </div>
        )}
      </Dropzone>
      {/* {props.showPreview && ( */}
      <div className="dropzone-previews" id="uploadPreviewTemplate">
        <Row>
          {!props.hideFiles &&
            selectedFiles.map((document, i) => {
              return (
                <div
                  key={document.name + i}
                  className="align-items-center shadow-none border m-1 rounded-pill p-1"
                  style={{
                    maxWidth: "fit-content",
                    display: "flex", // <--- hinzugefügt
                    alignItems: "center", // <--- hinzugefügt
                  }}
                >
                  {document.id ? (
                    <DocumentLink
                      key={document.id}
                      className="card-drop p-0 shadow-none text-muted "
                      style={{
                        color: "black",
                        textDecoration: document.delete
                          ? "line-through"
                          : "underline",
                        fontSize: "0.8rem",
                        marginRight: "8px",
                        cursor: "text",
                      }}
                      linkName={
                        document.name.length > 30
                          ? document.name.substring(0, 30) + "..."
                          : document.name
                      }
                      document={document}
                      collectionName={props.collectionName || "customerRequestItems"}
                      docId={document.id}
                    />
                  ) : (
                    <Button
                      className="card-drop p-0 shadow-none text-muted "
                      variant="outline"
                      href={document.url}
                      target="_blank"
                      rel="noreferrer"
                      style={{
                        color: "black",
                        textDecoration: "underline",
                        fontSize: "0.8rem",
                        marginRight: "8px",
                        cursor: "text",
                      }}
                    >
                      <HiddenValue dataClass="documents">
                        {document.name.length > 30
                          ? document.name.substring(0, 30) + "..."
                          : document.name}
                      </HiddenValue>
                    </Button>
                  )}

                  {(!document.id || user.type !== "customer") &&
                    (document.delete ? (
                      <Button
                        className="card-drop arrow-none cursor-pointer p-0 shadow-none me-1"
                        variant="outline"
                        onClick={() => reAddFile(i)}
                      >
                        <i className="mdi mdi-replay"></i>
                      </Button>
                    ) : (
                      <Button
                        className="card-drop arrow-none cursor-pointer p-0 shadow-none me-1"
                        variant="outline"
                        onClick={() => removeFile(i)}
                      >
                        <i className="mdi mdi-delete-outline"></i>
                      </Button>
                    ))}
                </div>
              );
            })}
        </Row>
      </div>
      {/* )} */}
    </>
  );
};

export default CompactFileUploader;
